<button [disabled]="isDisabled" class="btn btn-primary showHide-btn" [ngClass]="!isVisible ? 'push-right' : 'push-left'" (click)="onClick($event)">
  <span class="icon" [ngClass]="!isVisible ? 'icon-keyboard_arrow_right' : 'icon-keyboard_arrow_left'"></span>
</button>
